import { APICallV3Post } from 'reactApp/api/APICall';

export class GiftBuyAPICall extends APICallV3Post {
    _method = 'billing/gift/buy';
}
